import { PlessViewUtilsSub } from './../../../../commons/kymw00/pless-view-utils-sub.service';
import { KYMW9008Model } from '../kymw9008.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 多要素認証メソッド
 *
 * @export API通信成功時の処理
 * @class CheckMfaService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class CheckMfaService extends PlessJsonResponderSub<any> {

  // 処理に使用するModel
  private model: KYMW9008Model;
  private successFunc: Function;
  private vo = {
    EmailOtpCode: ''
  }


  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof CheckMfaService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        EmailOtpCode: this.vo.EmailOtpCode
      }
    })
  }

  /**
   * API呼び出し
   *
   * @param {KYMW9008Model} model
   * @param {any} vo
   * @param {Function} [successFunc=null] 成功時後続処理
   * @memberof CheckMfaService
   */
  execute(model: KYMW9008Model, successFunc: Function = null) {
    this.model = model;
    this.vo.EmailOtpCode = this.model.emailOtpCode;
    this.successFunc = successFunc;
    this.send('checkMfa', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof CheckMfaService
   */
  success(data: any) {
    if (this.successFunc !== null) {
        this.successFunc(data);
    }
  }

  /**
   * API通信失敗時の処理
   *
   * @param {string} status エラーステータス
   * @param {*} result エラー結果
   * @memberof CheckMfaService
   */
  exceptionError(status: string, result: any): void {
    this.dialogService.openAlertGetMessage('W0024', ['セキュリティコード'], () => { });
  }
}
